/**
 * Fields required before calling FE API lead submission / Leads API.
 * Matches the Leads API create-lead schema requirements that fail as 422s
 * when a user (or bot) hits /loading without completing the form.
 */
export const REQUIRED_LEAD_FIELDS = [
	"firstName",
	"lastName",
	"email",
	"dob",
	"state",
] as const;

export type RequiredLeadField = (typeof REQUIRED_LEAD_FIELDS)[number];

/**
 * Returns true when all required lead fields are present and non-empty.
 * Accepts either Formik step values or accumulated LocalStorage values.
 */
export function hasRequiredLeadFields(
	values: Record<string, unknown> | null | undefined,
): boolean {
	if (!values || typeof values !== "object") return false;

	return REQUIRED_LEAD_FIELDS.every((field) => {
		const value = values[field];
		return typeof value === "string" && value.trim().length > 0;
	});
}

/**
 * Lists which required fields are missing or blank.
 */
export function getMissingLeadFields(
	values: Record<string, unknown> | null | undefined,
): RequiredLeadField[] {
	if (!values || typeof values !== "object") {
		return [...REQUIRED_LEAD_FIELDS];
	}

	return REQUIRED_LEAD_FIELDS.filter((field) => {
		const value = values[field];
		return !(typeof value === "string" && value.trim().length > 0);
	});
}
